
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/industries",
      function () {
        return require("private-next-pages/industries.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/industries"])
      });
    }
  